import React, { useEffect, useState } from "react";
import LoadingPrimary from "@/components/LoadingPrimary";
import { useTranslation } from "react-i18next";

export default function WebsiteLoading({
  caseInfo,
}: {
  caseInfo: any;
}) {
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const { t } = useTranslation();
  useEffect(() => {
    const startedAt = Date.now();
    const intervalId = window.setInterval(() => {
      const seconds = Math.floor((Date.now() - startedAt) / 1000);
      setElapsedSeconds(seconds);
    }, 200);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="outline outline-[0.50px] outline-offset-[-0.50px] outline-[#e0e0e0] rounded-[20px] p-4 bg-white mt-4 flex flex-col gap-3">
      <LoadingPrimary width={22} />
      <div className="w-full text-center">
        <span className="text-font&icon-helper text-sm font-medium font-['DM_Sans'] leading-snug">
          {t("campaignCreate.websiteLoading.settingUpCampaign")}{" "}
        </span>
        <span className="text-font&icon-placeholder text-sm font-medium font-['DM_Sans'] leading-snug">
          (
        </span>
        <span className="text-font&icon-primary text-sm font-medium font-['DM_Sans'] leading-snug">
          {elapsedSeconds}s
        </span>
        <span className="text-font&icon-placeholder text-sm font-medium font-['DM_Sans'] leading-snug">
          /40s)
        </span>
      </div>
      {caseInfo?.imageSmallUrl && (
        <div className="bg-[#FAFAF9] rounded-[12px] p-8 flex gap-6 items-center">
          <div className="w-[216px] rounded-[12px] overflow-hidden">
            <img
              src={caseInfo?.imageSmallUrl}
              alt={caseInfo?.name}
              className="w-full"
            />
          </div>
          <div className="flex flex-col gap-4 flex-1">
            <div className="flex justify-between items-center">
              <div className="w-[150px]">
                <img
                  src={caseInfo?.logoUrl}
                  alt={caseInfo?.productName}
                  className="w-full"
                />
              </div>
              <div className="px-3 h-6 relative bg-[#202020] rounded-full flex items-center gap-2 cursor-pointer" onClick={() => {
                window.open(`https://aha.inc/case-studies/detail?type=${caseInfo?.redirectKey}`, "_blank");
              }}>
                <div className="text-white text-sm font-medium font-['Inter'] leading-none">
                  {t("campaignCreate.websiteLoading.readStory")}
                </div>
                <svg
                  width="10"
                  height="9"
                  viewBox="0 0 10 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.70382 4.37768C9.70382 4.54273 9.63461 4.70777 9.51748 4.81957L6.20072 8.13101C6.07294 8.25345 5.92921 8.31201 5.78014 8.31201C5.43941 8.31201 5.19451 8.07244 5.19451 7.74769C5.19451 7.57732 5.26372 7.42826 5.37552 7.32178L6.49885 6.18247L7.89903 4.91007L6.73843 4.97396H0.722475C0.360452 4.97396 0.115555 4.73439 0.115555 4.37768C0.115555 4.02631 0.360452 3.78674 0.722475 3.78674H6.73843L7.89371 3.85063L6.49885 2.57823L5.37552 1.43892C5.26372 1.32712 5.19451 1.18337 5.19451 1.01301C5.19451 0.688256 5.43941 0.443359 5.78014 0.443359C5.92921 0.443359 6.07827 0.507245 6.21137 0.635017L9.51748 3.94113C9.63461 4.05293 9.70382 4.21797 9.70382 4.37768Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <div className="self-stretch justify-start text-font&icon-helper text-sm font-normal font-['DM_Sans'] leading-snug">
              {caseInfo?.description}
            </div>
            <div className="flex gap-[84px]">
              {caseInfo?.dataSet?.map((item: any) => (
                <div
                  className="inline-flex flex-col justify-start items-start gap-1"
                  key={item?.value}
                >
                  <div className="justify-start text-font&icon-brand text-4xl font-normal font-['DM_Sans'] leading-10">
                    {item?.value}
                  </div>
                  <div className="text-center justify-start text-font&icon-helper text-xs font-semibold font-['DM_Sans'] leading-none">
                    {item?.key}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
